export const iconFontAwesomeMedicalHealthTruckDroplet = (
	<i className="fa-solid fa-truck-droplet"></i>
);
